import { Package } from "lucide-react";

export default function ProductImg({ src, name }) {
  return (
    <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-2xl border border-blue-100 bg-blue-50">
      {src ? <img src={src} alt={name} className="h-full w-full object-cover" /> : <Package className="h-5 w-5 text-blue-700" />}
    </div>
  );
}